import React from 'react';
import { Box } from '@mui/material';
import LegacyReportWidget from './LegacyReportWidget';

const LegacyReportLayout = ({ widgets }) => {
  if (!widgets.length) return null;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {widgets.map((widget) => (
        <LegacyReportWidget key={widget.id || `${widget.type}-${widget.params?.reportKey || ''}`} widget={widget} />
      ))}
    </Box>
  );
};

export default LegacyReportLayout;
